import styled from 'styled-components';

import { BodilColor, NorlysColor } from '~src/branding';
import { Icon } from '~src/components/Icon';

import { DotType } from './types';

export const Container = styled.div({
  padding: '24px',
});

export const Dot = styled.div<{ active?: boolean; simple?: boolean; type: DotType }>(({ active, simple, type }) => ({
  height: simple && !active ? '5px' : '10px',
  width: simple && !active ? '5px' : '10px',
  backgroundColor: getDotColor(type, active),
  borderRadius: '50%',
  boxShadow: type === 'dots-norlys' ? '0px 2px 4px rgba(0, 0, 0, 0.25);' : '',
}));

const getDotColor = (type: DotType, active = false) => {
  switch (type) {
    case 'dots-white': {
      return active ? BodilColor.base.white : BodilColor.greyscale[10];
    }

    case 'dots-norlys': {
      return active ? NorlysColor.primary.acid : BodilColor.base.white;
    }

    default: {
      return active ? BodilColor.base.default : BodilColor.greyscale[30];
    }
  }
};
export const DotContainer = styled.div({
  display: 'flex',
  justifyContent: 'center',
  gap: '8px',
});

export const CheckmarkContainer = styled.div({
  position: 'absolute',
  top: '-12px',
  right: '-12px',
  color: BodilColor.base.white,
  width: 'fit-content',
  borderRadius: 20,
  background: BodilColor.ui.orange,
});

export const ChevronContainer = styled.div({
  position: 'relative',
  margin: '0 -24px',
});

export const Chevron = styled(Icon.Chevron)<{ hover?: boolean }>(({ hover }) => ({
  width: 40,
  height: 40,
  zIndex: 1,
  marginBottom: 'auto',
  marginTop: 'auto',
  bottom: 0,
  top: 0,
  cursor: 'pointer',
  position: 'absolute',
  path: { fill: BodilColor.base.default },
  ...(hover && {
    '&:hover': {
      path: { fill: BodilColor.ui.orange },
    },
  }),
}));
